import React from 'react';
import ClassAssembly  from 'views/ClassAssembly12C2023';

const ClassAssemblyPage = () => {
    return <ClassAssembly />;
  };
  
  export default ClassAssemblyPage;